import { RedirectUrls } from '@cannect/constants/texts'
import type { CycleStatus, PauseReason, RecurrencySettings, SubscriptionStatus } from './types'

// Prazos do MVP usados só em texto de divulgação (research R4). Desconto,
// ciclos e entrega exibidos vêm do serviço; os limites de cada assinatura
// (editLockAt, maxPostponeAt, maxPauseUntil) vêm da própria assinatura.
export const RECURRENCY_MVP_SETTINGS: RecurrencySettings = {
  subscriberDiscountPercent: 5,
  cycleDaysOptions: [60, 90, 120],
  defaultCycleDays: 90,
  noticeDaysBeforeCharge: 7,
  editLockDaysBeforeCharge: 3,
  maxPostponeDays: 30,
  maxPauseDays: 90,
  deliveryDays: 30,
  postPurchaseAdhesionDays: 30
}

// "Minhas assinaturas" (/conta?pagina=assinaturas e assinaturas-<id>), feature 008.
export const SUBSCRIPTIONS_PAGE_PATH = '/conta?pagina=assinaturas'
export const SUBSCRIPTIONS_PAGE_READY = true
export const SUBSCRIPTION_DETAIL_PATH = (id: number) => `/conta?pagina=assinaturas-${id}`

// Limite do portal por item enquanto a API não preenche `allowedQuantityPerCycle`
// (delta D2); o servidor valida ao salvar.
export const MAX_QUANTITY_PER_ITEM = 6

// TODO(008): confirmar o número do acolhimento; hoje é o WhatsApp de vendas.
export const ACOLHIMENTO_WHATSAPP_URL: string = RedirectUrls.WHATSAPP_SALES

export const PAUSE_REASON_LABEL: Record<string, string> = {
  patient: 'Pausada por você',
  document: 'Pausada: receita vencida',
  payment: 'Pausada: cobrança recusada',
  stockout: 'Pausada pela Cannect',
  other: 'Pausada pela Cannect'
}

export const HISTORY_ACTOR_LABEL: Record<string, string> = {
  patient: 'Você',
  backoffice: 'Acolhimento Cannect',
  system: 'Sistema'
}

export const pauseReasonLabel = (reason: PauseReason | null) => (reason && PAUSE_REASON_LABEL[reason]) || 'Pausada'

export const SUBSCRIPTION_STATUS_LABEL: Record<SubscriptionStatus, string> = {
  active: 'Ativa',
  paused: 'Pausada',
  cancelled: 'Cancelada',
  ended: 'Encerrada'
}

export const CYCLE_STATUS_LABEL: Record<string, string> = {
  scheduled: 'Agendado',
  notified: 'Aviso enviado',
  locked: 'Em processamento',
  pending_payment: 'Aguardando pagamento',
  paid: 'Pago',
  failed: 'Cobrança recusada',
  skipped: 'Pulado',
  paused: 'Pausado',
  cancelled: 'Cancelado'
}

export const cycleStatusLabel = (status: CycleStatus) => CYCLE_STATUS_LABEL[status] || status

export const CANCEL_REASONS = [
  { value: 'not_needed', label: 'Não preciso mais' },
  { value: 'too_expensive', label: 'Ficou caro' },
  { value: 'treatment_changed', label: 'Meu tratamento mudou' },
  { value: 'prefer_one_time', label: 'Prefiro comprar quando precisar' },
  { value: 'other', label: 'Outro motivo' }
]

export const QUERY_KEYS = {
  all: ['recurrency'] as const,
  access: ['recurrency', 'subscriptions', 'access'] as const,
  subscriptions: (status?: SubscriptionStatus) => ['recurrency', 'subscriptions', status ?? 'all'] as const,
  subscription: (id: number) => ['recurrency', 'subscription', id] as const,
  eligibility: (
    ids: number[],
    qtys: number[],
    cycle: number | null | undefined,
    prices: boolean,
    origin?: string | null
  ) => ['recurrency', 'eligibility', ids, qtys, cycle ?? null, prices, origin ?? null] as const,
  terms: ['recurrency', 'terms'] as const,
  cards: ['recurrency', 'cards'] as const,
  adhesion: (orderId: number) => ['recurrency', 'adhesion', orderId] as const,
  preview: (id: number, body: unknown) => ['recurrency', 'preview', id, body] as const,
  adhesionPreview: (orderId: number, cycle: number | null | undefined) =>
    ['recurrency', 'adhesionPreview', orderId, cycle ?? null] as const
}
